import { UseForm } from '@brenger/react';
import { Validator } from '../../../../utils/validation';
import { CompanySchema, PersonSchema } from '../../schema';
import { RegisterFormFields } from './types';

export type RegisterFormState = UseForm.State<RegisterFormFields> | null;

export const nestedAddressAllValues = (prev: RegisterFormState): Record<string, unknown> => {
  const countryCode = prev?.country_code?.value ?? 'NL';
  return {
    user: {
      account: {
        address: {
          country_code: countryCode,
        },
      },
    },
  };
};

export const runCompanyValidators = (
  value: unknown,
  prev: RegisterFormState,
  schemaKey: keyof typeof CompanySchema
): string | boolean => {
  const allValues = nestedAddressAllValues(prev);
  const raw = CompanySchema[schemaKey];
  const list = (Array.isArray(raw) ? raw : [raw]) as ((...args: unknown[]) => string | undefined)[];
  for (const fn of list) {
    const err = fn.length >= 2 ? fn(value, allValues) : fn(value);
    if (err) {
      return err;
    }
  }
  return false;
};

export const personValidators = (key: keyof typeof PersonSchema): Validator[] => {
  const raw = PersonSchema[key];
  return (Array.isArray(raw) ? raw : [raw]) as Validator[];
};
